<template lang="pug">
    div(class="py-2 lg:py-0")
        div(
            @click="isOpen = !isOpen"
            class="uppercase text-gray-darkest cursor-pointer flex justify-between items-center border-b border-solid border-gray-light leading-none pb-2 mb-2 lg:pb-0 lg:mb-4 lg:cursor-default lg:text-white lg:border-none lg:leading-normal"
        )
            span(class="font-bold text-sm lg:text-lg") {{ title }}
            span(
                class="ml-2 text-xl lg:hidden"
                :class="isOpen ? 'text-lg' : 'text-xl'"
            ) {{ isOpen ? '&ndash;' : '+' }}

        div(
            class="ml-3 lg:ml-0 lg:block"
            :class="{ 'hidden': !isOpen }"
        )
            slot
                ul(class="space-y-3 flex flex-col")
                    template(v-for="link in links")
                        li
                            FlexLink(
                                :to="link.path"
                                :rel="link.rels ? link.rels.join(',') : null"
                                class="text-gray-darkest text-sm lg:text-white"
                            ) {{ link.text }}

</template>

<script>
import FlexLink from '@/components/flexLink'

export default {
    name: 'NavigationGroup',
    components: {
        FlexLink,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        links: {
            type: Array,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            isOpen: false,
        }
    },
}
</script>
